import React, { useState, useEffect,useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import ReCAPTCHA from "react-google-recaptcha"
import { Formik, Field, Form as FormikForm } from "formik";
import {FormikInputComponent} from "../../../utilities/formUtils";
import { Checkbox, Input, Icon, Divider,Form,Label } from "semantic-ui-react";
import PhoneInput from 'react-phone-number-input'
//https://catamphetamine.gitlab.io/react-phone-number-input/
import {gettingOTPCallMain} from "../data/action";
import lookup from "country-code-lookup"; // lookup.byCountry('United Kingdom')

const Signup_Step_Three = (props) => {
    const dispatch = useDispatch();
    const onchangehandle = (e,data) =>{
        if(e.target.name == "name"){
            props.setcurNameerrorClass("");
            props.setcustomNameErrorMsg("");
        // }else if(e.target.name == "mobile_no"){
        //     props.setcurNumbrerrorClass("");
        //     props.setcustomNumbrErrorMsg("");
        }else if(e.target.name == "password"){
            props.setcurPwerrorClass("");
            props.setcustomPwErrorMsg("");
        }else if(e.target.name == "verification_code"){
            props.setcurVerCodeerrorClass("");
            props.setcustomVerCodeErrorMsg("");
            props.setverificationOtpval(data.value)
        }
    }
    const phFieldsChange = (value)=>{
        props.setmobileno(value)
        props.setcurNumbrerrorClass("");
        props.setcustomNumbrErrorMsg("");
    }
    const phcountryFieldsChange = (value)=>{
        props.setcountrymob(value)
        props.setcurNumbrerrorClass("");
        props.setcustomNumbrErrorMsg("");
        console.log("lookup.byInternet(value)==",lookup.byInternet(value))
        props.setselectedCountry(lookup.byInternet(value)?.country);
    }
    const resendOtp = (value) => {  
        dispatch(gettingOTPCallMain({
            data:props.values.email_id,
            curState:props.curState
        }));
    }
    const onchangekeyDown = (e)=>{
        if(e.keyCode == 61 && !e.shiftKey){
            e.preventDefault();
        }
    }
    return(
        <div style={{display :props.displayparam}}>
            <div className="sign-up-head">
                <h3 className="signuptxt">Sign Up</h3>
            </div>
            <div className="progress-container">
                <div className="progress" id="progress"></div>
                <div className="circle green"></div>
                <div className="circle active"></div>
                <div className="circle"></div>
                <div className="circle"></div>
                <div className="circle"></div>
                <div className="circle"></div>
            </div>
            <div className="sign-up-form-info">
                    <div className="mb-3">
                        <Form.Group widths='equal'>
                        <Form.Field>
                                <label for="" className="sign-up-field-name form-label">Name</label>
                                <Field
                                    id="name"
                                    name="name"
                                    noLabel="y"
                                    component={FormikInputComponent}
                                    icontoShow = 'user'
                                    iconPosition='left'
                                    placeholder = "Enter your name"
                                    // style={{marginTop:"11px"}}
                                    className={props.curNameerrorClass+" commonnameregInput"}
                                    myChangeFunction = {onchangehandle}
                                    iserror={props.curNameerrorClass != "" ? true : false}
                                    customErrorMsg = {props.customNameErrorMsg}
                                />
                            </Form.Field>
                                {/* <Input name=" size="large" className="signupinputs"/> */}
                            <Form.Field width={1}></Form.Field>
                            <Form.Field>
                                <label for="" className="sign-up-field-name form-label">Mobile Number</label>
                                <Form.Field className={props.curNumbrerrorClass}>
                                    <PhoneInput
                                    international
                                    countryCallingCodeEditable={false}
                                    defaultCountry="IN"
                                    name="mobile_no"
                                    value={props.mobileno}
                                    onChange={phFieldsChange}
                                    onCountryChange={phcountryFieldsChange}
                                    placeholder="Enter your number"
                                    className="phoneinputSt"
                                    />
                                    {
                                        props.curNumbrerrorClass == "error" ?
                                        <Label size="mini" color='red' basic pointing prompt>{props.customNumbrErrorMsg}</Label> 
                                        :
                                        <></>
                                    }
                                </Form.Field>
                                
                                {/* <Field
                                    id="mobile_no"
                                    name="mobile_no"
                                    noLabel="y"
                                    component={FormikInputComponent}
                                    icontoShow = 'call'
                                    iconPosition='left'
                                    placeholder = "Enter your number"
                                    // style={{marginTop:"11px"}}
                                    className={props.curNumbrerrorClass}
                                    myChangeFunction = {onchangehandle}
                                    iserror={props.curNumbrerrorClass != "" ? true : false}
                                    customErrorMsg = {props.customNumbrErrorMsg}
                                /> */}
                            </Form.Field>
                        </Form.Group>
                        <Form.Group widths='equal'>
                            <Form.Field>
                                <label for="" className="sign-up-field-name form-label marginTopSecondRow">Create Password</label>
                                <Field
                                    id="password"
                                    name="password"
                                    noLabel="y"
                                    component={FormikInputComponent}
                                    icontoShow = 'lock'
                                    iconPosition='left'
                                    placeholder = "Min 8 characters"
                                    inputtype="password"
                                    // style={{marginTop:"11px"}}
                                    className={props.curPwerrorClass+" commonnameregInput"}
                                    myChangeFunction = {onchangehandle}
                                    mykeyDownFunction = {onchangekeyDown}
                                    iserror={props.curPwerrorClass != "" ? true : false}
                                    customErrorMsg = {props.customPwErrorMsg}
                                />
                                {/* <Input icon='lock' iconPosition='left' placeholder='Minimum 8 characters' size="large" className="signupinputs"/> */}
                                <div className="otp-info">1 special character, 1 number, 1 upper case and 1 lower case</div>
                            </Form.Field>
                            <Form.Field width={1}></Form.Field>
                            <Form.Field>
                                <label for="" className="sign-up-field-name form-label marginTopSecondRow">Email Verification Code</label>
                                <Field
                                    id="verification_code"
                                    name="verification_code"
                                    noLabel="y"
                                    component={FormikInputComponent}
                                    icontoShow = 'key'
                                    iconPosition='left'
                                    placeholder = "Enter the OTP"
                                    // style={{marginTop:"11px"}}
                                    className={props.curVerCodeerrorClass+" commonnameregInput"}
                                    myChangeFunction = {onchangehandle}
                                    iserror={props.curVerCodeerrorClass != "" ? true : false}
                                    customErrorMsg = {props.customVerCodeErrorMsg}
                                />
                                {/* <Input icon='key' iconPosition='left' placeholder='Enter the OTP' size="large" className="signupinputs"/> */}
                                <div className="otp-info">OTP has been sent to {props.values.email_id}</div>
                            </Form.Field>
                        </Form.Group>
                        <div className="otp-info alignCenter beforeButtonText">Didn't receive the OTP? <a className="cursorPointer" onClick={resendOtp}>Resend</a></div>
                    </div>
            </div>
        </div>
    )
}
export default Signup_Step_Three;